import { render, staticRenderFns } from "./CommentHistory.vue?vue&type=template&id=3ad6af52&scoped=true&"
import script from "./CommentHistory.vue?vue&type=script&lang=js&"
export * from "./CommentHistory.vue?vue&type=script&lang=js&"
import style0 from "./CommentHistory.vue?vue&type=style&index=0&id=3ad6af52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6af52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad6af52')) {
      api.createRecord('3ad6af52', component.options)
    } else {
      api.reload('3ad6af52', component.options)
    }
    module.hot.accept("./CommentHistory.vue?vue&type=template&id=3ad6af52&scoped=true&", function () {
      api.rerender('3ad6af52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/CommentHistory.vue"
export default component.exports